module.exports = __webpack_public_path__ + "9c992e01002a2d6322fdda24447aecf3.png";